import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { SessionData } from 'src/app/domain/session-data';
import { URL_USER_INFO_NBE } from 'src/app/shared/config-urls';
import { UserData } from 'src/app/domain/user-data';

@Injectable({
  providedIn: 'root'
})
export class UserinfoService {

  constructor(private httpService: HttpService) { }

  getUserInfo(sessionData: SessionData, userData: UserData) {
    return this.httpService.post(this.getUserInfoURL(),
      this.getUserInfoRequestBody(sessionData, userData), sessionData.agreementMap);
  }

  private getUserInfoURL() {
    return `${URL_USER_INFO_NBE}`;
  }

  private getUserInfoRequestBody (sessionData: SessionData, userData: UserData) {
      return this.getUserInfoNBERequestBody(sessionData, userData);
  }

  private getUserInfoNBERequestBody(sessionData: SessionData, userData: UserData) {
    return {
      'nbeUserInfoRequest': {
        'security_token': sessionData.sessionToken,
        'agreement': sessionData.agreementType,
        'operation_type': (sessionData.agreementType === 'P') ? '001' : ''
      }
    };
  }
}
